import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { NotificationsService } from 'angular2-notifications';
import { GetMonthlyTargetListVM, MonthlyDashboardMessageVM, SiteCodes } from '../entities/global/model';
import { SafetyConfigService } from '../services/safety-config.service';
import { MonthlyAlertDialogComponent } from './monthly-alert-dialog/monthly-alert-dialog.component';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-config-add-montly-dashbrd-message',
  templateUrl: './config-add-montly-dashbrd-message.component.html',
  styleUrls: ['./config-add-montly-dashbrd-message.component.css']
})
export class ConfigAddMontlyDashbrdMessageComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<ConfigAddMontlyDashbrdMessageComponent>,
    private _safetyConfigService: SafetyConfigService,
    public toastr: NotificationsService, vcr: ViewContainerRef,
    public dialog: MatDialog,
  ) {

  }


  MonthlyDashboardMessageVM: MonthlyDashboardMessageVM
  mydate = new Date();
  Month: number
  Year: number
  FocusItems
  AreasImprovement
  Positives
  Take5Target: number = 0
  SafetyInspTarget: number = 0
  inputValuestate: number
  siteCodesList: SiteCodes[] = [];
  TargetList: GetMonthlyTargetListVM[] = [];


  ngOnInit() {
    this.Year = this.mydate.getFullYear();
    this.Month = this.mydate.getMonth() + 1;
    this.loadSiteList();

  }


  state = new FormControl("", [Validators.required]);
  getErrorMessage() {
    return this.state.hasError("required") ? "You must enter a value" : "";
  }


  loadSiteList() {
    this._safetyConfigService.getAllSitesList().subscribe(sites => {
      console.log('sitelist', sites)
      this.siteCodesList = sites;

    });
  }
  DialogClose() {
    this.dialogRef.close(false)
  }

  monthName(mon) {
    return ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'][mon - 1];
 }

  selectstate(state) {
    
    if (state.value) {
      this._safetyConfigService.GetMonthlyTargetList(state.value, this.Month, this.Year).subscribe(res => {
        console.log("res", res)
        this.TargetList = res
      })
    } else {
      this.TargetList = []
    }

  }

  saveMessage() {


    let model = new MonthlyDashboardMessageVM();
    model.Month = this.Month;
    model.Year = this.Year;
    model.FocusItems = this.FocusItems;
    model.AreasImprovement = this.AreasImprovement;
    model.Positives = this.Positives;
    model.Take5Target = this.Take5Target;
    model.SafetyInspTarget = this.SafetyInspTarget;
    model.inputValuestate = this.inputValuestate;


    this._safetyConfigService.checkMonthlyDashboardMessagesubmit(model).subscribe((res: any) => {
      if (res.length != 0) {

        this.OpenNewFialog(model, res);

      }
      else {

        this._safetyConfigService.addMonthlyDashboardMessage(model).subscribe((r: any) => {

          if (r = true) {
            if (model.Month != null && model.Year != null)

              this.toastr.success('Saved');
          }
          else {
            this.toastr.error('Error');
          }

        })
      }

    })


    this.DialogClose();
  }

  ChangeMonth(month){
    if (month.value) {
      this._safetyConfigService.GetMonthlyTargetList(this.inputValuestate, month.value, this.Year).subscribe(res => {
        //console.log("res", res)
        if(res != null &&res.length >0 ){
          this.TargetList = res.sort((a, b) => a.Sort - b.Sort);
        }else{
          this.TargetList = []
        }
        
      })
    } else {
      this.TargetList = []
    }
  }

  ChangeYear(year){
    if (year.value) {
      this._safetyConfigService.GetMonthlyTargetList(this.inputValuestate, this.Month, year.value).subscribe(res => {
        //console.log("res", res)
        if(res != null &&res.length >0 ){
          this.TargetList = res.sort((a, b) => a.Sort - b.Sort);
        }else{
          this.TargetList = []
        }
      })
    } else {
      this.TargetList = []
    }
  }

  OpenNewFialog(modelParams: MonthlyDashboardMessageVM, resParams: MonthlyDashboardMessageVM) {
    const dialogRef = this.dialog.open(MonthlyAlertDialogComponent, {
      disableClose: true,
      data: {
        model: modelParams,
        res: resParams
      }

    });

  }

}
